export const checkStatus = async (response) => {
  if (response.ok) {
    return Promise.resolve(response)
  } else {
    const body = await response.json()
    return Promise.reject(new Error(body.error_description))
  }
}

export const returnJson = (response) => {
  return response.json()
}
